import { useTranslation } from "react-i18next";
import InputField from "../../components/shared/InputField";
import MultiSelect from "../../components/shared/MultiSelect";
import NormalButton from "../../components/shared/NormalButton";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import PageMain from "../../containers/shared/PageMain";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../../App";
import apiClient from "../../components/utils/apiClient";
import DateField from "../../components/shared/DateField";
import MultiImagesCompress from "../../components/helpers/MultiImagesCompress";
import Loading from "../../components/shared/Loading";
import {initializeApp, getApp, getApps} from "firebase/app";
import { getStorage, uploadBytes } from "firebase/storage";
import { getDownloadURL, ref } from "firebase/storage";
import { firebaseConfig } from "../../components/utils/constants";
import moment from "moment";
import useUser from "../../components/helpers/useUser";

const AssetsAddPage = () => {

    const [user, setUser] = useUser();

    const [isLoading, setIsLoading] = useState(false);
    const AttachmentFilesRef = useRef(null);
    const [attachmentsFiles, setAttachmentsFiles] = useState([]);
    const { AssetTypeOptions, AssetsStatusOptions } = useContext(UserContext);
    
    const {t,i18n} = useTranslation();
    useDocumentTitle('إضافة أصل جديد');
    const navigate = useNavigate();
    const pageTitle = {title: 'إضافة أصل جديد', subTitle: 'يمكنك إضافة أصل جديد من هنا.'};
    const EmptyAddAssetsForm = {
        type: "",
        status: "",
        brand: "",
        serialNumber: "",
        costPerItem: "",
        depreciationRate: "",
        propertyId: "",
        quantity:0,
        unitId: "",
        purchaseDate: "",
        installationDate: "",
        lastMaintenanceDate: "",
        expectedLifeSpan: "",
        hasWarranty: "",
        attachments: [],
    };
    const [addAssetsForm,setAddAssetsForm] = useState(EmptyAddAssetsForm);
    const [errors, setErrors] = useState(null);
    const [isAddAssetsFormDisabled, setIsAddAssetsFormDisabled] = useState(true);

    const [unitsOptions, setUnitsOptions] = useState([]);
    const getUnits = async () => {
    try {
        const response = await apiClient.get(`/b-units?business=${user?.business?._id ? user?.business._id : user?.business}`);
        if(response?.data) {
          setUnitsOptions(response?.data?.filter(u=>!u?.deletedAt)?.map(unit => ({value: unit?._id, label: unit?.name, propertyId: unit?.propertyId})));
        }
      } catch(err) {}
  }
  useEffect(()=>{
    getUnits();
  },[])

    const handleSubmitAddAssets = async () => {
        setIsAddAssetsFormDisabled(true);
        if(attachmentsFiles?.length > 0) { 
            setIsLoading(true);
            MultiImagesCompress(attachmentsFiles).then(compressedImages=>uploadFiles(compressedImages));
        } else {
            sendToServer();
        }
    }

    const uploadFiles = async(files) => {
        await Promise.all(files.map(async (file,index) => await singleFileUpload(file,index)  ))
    .then((resolvedFiles) => {
        sendToServer(resolvedFiles);
    })
    .catch(error => {
        console.error(`Error occured during images uploading: ${error}`);
    });
    }

    const singleFileUpload = async (file,index) => {
        const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
        const storage = getStorage(app);
        const time = Date.parse(moment().locale('en').format('YYYY-MM-DD HH:mm:ss')) / 1000;
        const storageRef = ref(storage,'fanni-business/AssetsWarrenty/'+time+'-'+index);

        const imageToServer = uploadBytes(storageRef,file);
        return await imageToServer.then((snapshot) => {
        return getDownloadURL(snapshot.ref).then( url => {
            return { url : url, name: file.name, type: file.type }
        });
        ;
        });
    }

            

    const sendToServer = async (files=null) => {
        const finalAddAssetsForm = JSON.parse(JSON.stringify(addAssetsForm));
        finalAddAssetsForm.costPerItem = parseInt(finalAddAssetsForm.costPerItem);
        finalAddAssetsForm.depreciationRate = parseFloat(finalAddAssetsForm.depreciationRate);
        finalAddAssetsForm.expectedLifeSpan = parseInt(finalAddAssetsForm.expectedLifeSpan);
        if(files) {
            finalAddAssetsForm.attachments = files;
        }
        try {
        const response = await apiClient.post(`/b-assets`,Object.fromEntries(Object.entries(finalAddAssetsForm).filter(([_, v]) => v !== '')));
        if(response?.data) {
            navigate(`/ar/assets`);
            setIsLoading(false);
        } else {
            setIsAddAssetsFormDisabled(false);
            setIsLoading(false);
        }
        } catch(err) {
            setIsAddAssetsFormDisabled(false);
            setIsLoading(false);
            if(err?.response?.data?.errors) {
                let errorsList = {};
                err?.response?.data?.errors?.map(err=>{
                    errorsList[err.field] = err.message; 
                });
                setErrors(errorsList);
            }
        }
    }

    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }

    useEffect(()=>{
        if(addAssetsForm 
            && addAssetsForm?.type && addAssetsForm?.type !== ''
            && addAssetsForm?.status && addAssetsForm?.status !== ''
            && addAssetsForm?.brand && addAssetsForm?.brand !== ''
            && addAssetsForm?.serialNumber && addAssetsForm?.serialNumber !== ''
            && addAssetsForm?.costPerItem && addAssetsForm?.costPerItem !== ''
            && addAssetsForm?.depreciationRate && addAssetsForm?.depreciationRate !== ''
            && addAssetsForm?.unitId && addAssetsForm?.unitId !== ''
            && addAssetsForm?.purchaseDate && addAssetsForm?.purchaseDate !== ''
            && addAssetsForm?.lastMaintenanceDate && addAssetsForm?.lastMaintenanceDate !== ''
            && addAssetsForm?.expectedLifeSpan && addAssetsForm?.expectedLifeSpan !== ''
            && addAssetsForm?.hasWarranty !== '' && [true,false].includes(addAssetsForm?.hasWarranty)) {
            setIsAddAssetsFormDisabled(false);
        } else {
            setIsAddAssetsFormDisabled(true);
        }
    },[addAssetsForm])



    const depreciationRateOptions = [
        {label:'1%', value: '0.01'},
        {label:'2%', value: '0.02'},
        {label:'3%', value: '0.03'},
        {label:'4%', value: '0.04'},
        {label:'5%', value: '0.05'},
        {label:'6%', value: '0.06'},
        {label:'7%', value: '0.07'},
        {label:'8%', value: '0.08'},
        {label:'9%', value: '0.09'},
        {label:'10%', value: '0.1'},
    ]

    const TrueOrFalseOptions = [
        {label:'نعم', value: true},
        {label:'لا', value: false},
    ]


    const handleClickAttachments = () => {
        AttachmentFilesRef.current.click();
    }

    const handleChangeAttachments = (e) => {
        setAttachmentsFiles([...attachmentsFiles, ...Array.from(e.target.files)]);
    }

    const removeAttachment = (file) => {
        const newAttachmentsFiles = [...Array.from(attachmentsFiles).filter((f) => f?.name !== file?.name)];
        setAttachmentsFiles(newAttachmentsFiles);
    }


    
    return (
        <div> 
        <PageHeader pageTitle={pageTitle} />
        <PageMain>
            <span className="absolute top-0 left-0 right-0 bottom-0 z-0 bg-grey-50"></span>
            <MainContent>
                <NormalFormContainer heading="من فضلك قم بملئ البيانات التالية لإضافة أصل جديد." label="أضف أصل">
                    
                    <div className="mb-[15px]">
                        <MultiSelect label={'النوع'} placeholder={'اختر نوع الأصل'} options={AssetTypeOptions} error={errors?.type} errorMessage={errors?.type} value={addAssetsForm?.type && AssetTypeOptions[AssetTypeOptions?.findIndex(option => option?.value === addAssetsForm?.type)]} onChange={(option)=>{setAddAssetsForm({ ...addAssetsForm, type: option?.value }); hideError('type')}} />
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'الحالة'} placeholder={'اختر حالة الأصل'} options={AssetsStatusOptions} error={errors?.status} errorMessage={errors?.status} value={addAssetsForm?.status && AssetsStatusOptions[AssetsStatusOptions?.findIndex(option => option?.value === addAssetsForm?.status)]} onChange={(option)=>{setAddAssetsForm({ ...addAssetsForm, status: option?.value }); hideError('status')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'الماركة'} placeholder={'اكتب ماركة الأصل'} value={addAssetsForm?.brand} error={errors?.brand} errorMessage={errors?.brand} translateError={true} onChange={(e)=>{setAddAssetsForm({ ...addAssetsForm, brand: e.target.value }); hideError('brand')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'رقم السريال'} placeholder={'اكتب رقم السريال هنا'} value={addAssetsForm?.serialNumber} error={errors?.serialNumber} errorMessage={errors?.serialNumber} translateError={true} onChange={(e)=>{ setAddAssetsForm({ ...addAssetsForm, serialNumber: e.target.value }); hideError('serialNumber')}} />
                    </div>

                    <div className="mb-[15px] relative">
                        <InputField label={'القيمة'} placeholder={'اكتب سعر الأصل هنا'} value={addAssetsForm?.costPerItem} error={errors?.costPerItem} errorMessage={errors?.costPerItem} translateError={true} onChange={(e)=>{  if(e.target.value === '' || e.target.value === '0' || /^\d*[1-9]\d*$/.test(e.target.value)) { setAddAssetsForm({ ...addAssetsForm, costPerItem: e.target.value }) }; hideError('costPerItem')}} />
                        <span className="absolute top-[41px] end-[15px] w-[13px] h-[13px]" style={{background:"url('/assets/images/SAR-mini.svg')"}}></span>
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'نسبة الإهلاك'} placeholder={'اختر نسبة الإهلاك السنوية'} options={depreciationRateOptions} error={errors?.depreciationRate} errorMessage={errors?.depreciationRate} value={addAssetsForm?.depreciationRate && depreciationRateOptions[depreciationRateOptions?.findIndex(option => option?.value === addAssetsForm?.depreciationRate)]} onChange={(option)=>{setAddAssetsForm({ ...addAssetsForm, depreciationRate: option?.value }); hideError('depreciationRate')}} />
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'الوحدة'} placeholder={'اختر الوحدة الموجود بها الأصل'} options={unitsOptions} error={errors?.unitId} errorMessage={errors?.unitId} value={addAssetsForm?.unitId && unitsOptions[unitsOptions?.findIndex(option => option?.value === addAssetsForm?.unitId)]} onChange={(option)=>{setAddAssetsForm({ ...addAssetsForm, unitId: option?.value, propertyId: option?.propertyId }); hideError('unitId')}} />
                    </div>

                    <div className="mb-[15px]">
                        <DateField label={'تاريخ الشراء أو التركيب'} placeholder={'اختر يوم تركيب الأصل أو الشراء اذا لم يركب بعد'} value={addAssetsForm?.purchaseDate} error={errors?.purchaseDate} errorMessage={errors?.purchaseDate} translateError={true} onChange={(date)=>{ setAddAssetsForm({ ...addAssetsForm, purchaseDate: date, installationDate: date }); hideError('purchaseDate')}} />
                    </div>

                    <div className="mb-[15px]">
                        <DateField label={'تاريخ آخر صيانة'} placeholder={'اختر يوم آخر صيانة تمت علي الأصل'} value={addAssetsForm?.lastMaintenanceDate} error={errors?.lastMaintenanceDate} errorMessage={errors?.lastMaintenanceDate} translateError={true} onChange={(date)=>{ setAddAssetsForm({ ...addAssetsForm, lastMaintenanceDate:date }); hideError('lastMaintenanceDate')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'عمر الأصل المتوقع'} placeholder={'اكتب عمر الأصل المتوقع بالسنين'} value={addAssetsForm?.expectedLifeSpan} error={errors?.expectedLifeSpan} errorMessage={errors?.expectedLifeSpan} translateError={true} onChange={(e)=>{  if(e.target.value === '' || e.target.value === '0' || /^\d*[1-9]\d*$/.test(e.target.value)) { setAddAssetsForm({ ...addAssetsForm, expectedLifeSpan: e.target.value }) }; hideError('expectedLifeSpan')}} />
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'الضمان'} placeholder={'اختر هل يوجد ضمن أصل ام لا'} options={TrueOrFalseOptions} error={errors?.unitId} errorMessage={errors?.unitId} value={addAssetsForm?.unitId && TrueOrFalseOptions[TrueOrFalseOptions?.findIndex(option => option?.value === addAssetsForm?.hasWarranty)]} onChange={(option)=>{setAddAssetsForm({ ...addAssetsForm, hasWarranty: option?.value }); hideError('hasWarranty')}} />
                    </div>

                    <div className="mb-[15px]">
                        <label className="text-grey-900 text-[14px] font-[600] leading-[21px] mb-[3px] block">مستندات الضمان</label>
                        <div className="flex flex-nowrap gap-x-[10px] mb-[5px]">
                            <div className="w-[50%] text-[16px] font-[500] text-grey-600">
                                قم بتحميل مستندات الضمان إن وجد
                            </div>
                            <div className="w-[50%] text-end">
                                <div className="inline-block text-blue text-[16px] font-[500] cursor-pointer select-none" onClick={handleClickAttachments}>
                                    <span className="inline-block align-middle w-[24px] h-[24px] me-[8px]" style={{background:"url('/assets/images/export.svg')"}}></span>
                                    تحميل المستندات
                                </div>
                            </div>
                        </div>
                        <input type="file" ref={AttachmentFilesRef} className="hidden" multiple accept="image/jpeg, image/png, application/pdf" onChange={handleChangeAttachments} />
                        <div className="">
                            {attachmentsFiles?.length > 0 && <div className="mb-[15px]">
                                {attachmentsFiles?.map((file,index)=>{
                                    return (<div key={`attachment-${index}`} className="text-[16px] font-[500] text-grey-600">
                                        <span className="inline-block align-middle w-[24px] h-[24px] me-[3px]" style={{background:"url('/assets/images/tick-circle.svg')"}}></span>
                                        {file?.name}
                                        <span className="inline-block align-middle w-[24px] h-[24px] ms-[6px] cursor-pointer select-none" style={{background:"url('/assets/images/close-square.svg')"}} onClick={()=>removeAttachment(file)}></span>
                                    </div>)
                                })}
                            </div>}
                        </div>
                    </div>


                    <div className="text-end">
                        <NormalButton label={'إضافة الأصل'} onClick={handleSubmitAddAssets} isDisabled={isAddAssetsFormDisabled} />
                    </div>

                </NormalFormContainer>
            </MainContent>
        </PageMain>

        {isLoading && <Loading showLoading={true} />}
        </div>
    )

}

export default AssetsAddPage;